import PageTitle, { PageTitleAction } from '@components/molecules/PageTitle'

export default function BranchConfigTitle(): JSX.Element {
  const actions: PageTitleAction[] = []

  return <PageTitle title="설정" actions={actions} />
}
